import { render, staticRenderFns } from "./roomProperties.vue?vue&type=template&id=017ef35d&scoped=true"
import script from "./roomProperties.vue?vue&type=script&lang=js"
export * from "./roomProperties.vue?vue&type=script&lang=js"
import style0 from "./roomProperties.vue?vue&type=style&index=0&id=017ef35d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ef35d",
  null
  
)

export default component.exports